import { CommonService } from "../common/common.service";
import { Subject } from "rxjs";
import { NetworkStatus } from '@capacitor/core';

export abstract class NetworkService implements CommonService {
	public networkChangeState$: Subject<boolean> = new Subject();

	abstract intinialize();

	abstract pushState(state: NetworkStatus);

	abstract unsubscribeNetworkChange();

	protected abstract registerNetworkChange();
}
